function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25 13.2983C25 12.4146 24.9297 11.5261 24.7798 10.6567H12.7507V15.6628H19.6392C19.3533 17.2774 18.4349 18.7056 17.09 19.6132V22.8614H21.1996C23.6129 20.5972 25 17.2535 25 13.2983Z",
  fill: "#4285F4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7504 26.0001C16.19 26.0001 19.0907 24.8489 21.2041 22.8618L17.0944 19.6136C15.951 20.4065 14.4749 20.8555 12.7551 20.8555C9.42804 20.8555 6.60705 18.5675 5.59487 15.4912H1.354V18.8397C3.51895 23.2296 7.92851 26.0001 12.7504 26.0001Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.59083 15.491C5.05662 13.8764 5.05662 12.1281 5.59083 10.5136V7.16504H1.35465C-0.454156 10.8384 -0.454156 15.1661 1.35465 18.8395L5.59083 15.491Z",
  fill: "#FBBC04"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7504 5.14449C14.5686 5.11583 16.3259 5.81324 17.6427 7.09341L21.2837 3.38186C18.9782 1.17499 15.9182 -0.0383147 12.7504 -0.000100508C7.92851 -0.000100508 3.51895 2.77043 1.354 7.16507L5.59018 10.5136C6.59768 7.43257 9.42336 5.14449 12.7504 5.14449Z",
  fill: "#EA4335"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 26,
  fill: "white"
})));

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/GoogleLogo.cc412750.svg";
export { ForwardRef as ReactComponent };